<template>
  <v-container fluid>
    <div>
      <div class="error" v-if="error">
        <p>{{ error }}</p>
      </div>

      <div class="field">
        <InputField
          v-model="form.firstName"
          :labelTitle="$t('dash.patient.create.form-firstname')"
          required
          :disabled="epdIntegration"
          :placeholder="$t('dash.patient.create.form-firstname')"
          margin="25px auto"
          ref="firstName"
        ></InputField>

        <InputField
          v-model="form.lastName"
          :labelTitle="$t('dash.patient.create.form-lastname')"
          :disabled="epdIntegration"
          required
          :placeholder="$t('dash.patient.create.form-lastname')"
          margin="0 auto 25px auto"
        ></InputField>

        <InputField
          v-if="!patient"
          v-model="form.birthday"
          :labelTitle="$t('dash.patient.create.form-date')"
          required
          type="date"
          :maxDate="new Date().toISOString().split('T')[0]"
          margin="25px auto"
          ref="firstName"
        ></InputField>

        <InputField
          v-model="form.crib"
          :labelTitle="$t('dash.patient.create.form-crib')"
          :disabled="epdIntegration"
          type="text"
          :placeholder="$t('dash.patient.create.form-crib')"
          required
          margin="0 auto 25px auto"
        ></InputField>

        <div style="text-align: left; color: red; padding-left: 90px; display: block" v-if="errorWeight">
          <p class="">{{ errorWeight }}</p>
        </div>
        <InputField
          v-if="!patient"
          v-model="form.weight"
          :labelTitle="$t('dash.patient.create.form-weight')"
          step="any"
          :placeholder="0"
          type="number"
          unit="g"
          margin="0 auto 25px auto"
        ></InputField>

        <div style="text-align: left; color: red; padding-left: 70px; display: block" v-if="errorLength">
          <p class="">{{ errorLength }}</p>
        </div>
        <InputField
          v-if="!patient"
          v-model="form.length"
          :labelTitle="$t('dash.patient.create.form-length')"
          :placeholder="0"
          type="number"
          unit="cm"
          margin="0 auto 25px auto"
        ></InputField>


        <div class="locale-select">
          <p>{{ $t("dash.patient.create.form-language") }}:</p>
          <ul class="locale-radio">
            <li v-for="locale in getAllSupportedLocales()" :key="locale">
              <label :for="locale" class="checkbox-container">
                {{ $t(`general.languages.${locale}`) }}
                <input
                  type="checkbox"
                  :id="locale"
                  :value="locale"
                  v-model="form.selectedLocales"
                />
                <span class="checkmark"></span>
              </label>
            </li>
          </ul>
        </div>

        <div v-if="!patient && !$store.getters.user.hospital.useCuraeConsent" class="consent-checkbox">
          <label for="informedConsent" class="checkbox-container">
            {{ $t("dash.patient.create.confirm-consent-1a") }}
            {{ $t("dash.patient.create.confirm-consent-1b") }} <span class="pink--text">*</span>
            <input
              type="checkbox"
              id="informedConsent"
              v-model="form.consent"
            />
            <span class="checkmark"></span>
          </label>
        </div>

        <LoadingButton v-if="loading"></LoadingButton>
        <div v-else>
          <Button
            v-if="!patient"
            type="submit"
            width="200"
            title="Toevoegen"
            style="margin: 16px 0"
            @click.native="writePatient('add')"
          ></Button>
          <Button
            v-else
            type="submit"
            width="200"
            title="Opslaan"
            style="margin: 16px 0"
            @click.native="writePatient('edit')"
          ></Button>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import {neoparentPatients, neoparentPosts} from "@/api";
import { getSupportedLocales } from "@/helpers";

export default {
  props: ["nurseId"],
  name: "neoparent-create-patient",
  computed: {
    requiredFieldsFilledIn(){
      if (!this.form.firstName)
        return false
      if (!this.form.lastName)
        return false
      if (!this.form.birthday)
        return false
      if (!this.form.crib)
        return false
      if (!this.form.consent && !this.$store.getters.user.hospital.useCuraeConsent)
        return false

      return true
    },
    errorWeight(){
      if (this.form.weight) {
        if (this.form.weight >= 10000 || this.form.weight <= 400) {
          return this.$t('error.bioDataEntry.weight')
        }
      }

      return null
    },
    errorLength(){
      if (this.form.length) {
        if (this.form.length >= 150 || this.form.length <= 15) {
          return this.$t('error.bioDataEntry.length')
        }
      }

      return null
    },
  },
  data() {
    return {
      epdIntegration: false,
      error: "",
      form: {
        firstName: "",
        lastName: "",
        birthday: "",
        crib: null,
        length: null,
        weight: null,
        selectedLocales: [],
        consent: false
      },
      editId: new URL(window.location).searchParams.get("patientId"),
      patient: null,
      loading: false
    };
  },
  mounted() {
    this.epdIntegration = this.$store.getters.user.hospital.epdSettings?.epdEnabled;
    this.$refs.firstName.$el.children[1].focus();
    if (this.editId) {
      neoparentPatients
        .getPatient(this.editId)
        .then(result => {
          this.consoleLog(result);
          this.patient = result.data.patient;
          this.form.firstName = this.patient.firstName;
          this.form.lastName = this.patient.lastName;
          this.form.crib = this.patient.crib;
          this.form.selectedLocales = result.data.patient.languages ? JSON.parse(result.data.patient.languages) : []
        })
        .catch(err => {
          this.consoleLog(err);
        });
    }
  },
  methods: {
    getAllSupportedLocales() {
      return getSupportedLocales("all", this.$store.getters.user.language)
    },
    writePatient(action) {
      if (this.requiredFieldsFilledIn || action === "edit") {
        if (action !== "add" && action !== "edit") return;
        this.loading = true;

        if (action === "add") {
          // Create new
          this.consoleLog("Creating patient");

          const data = {
            patient: {
              firstName: this.form.firstName,
              lastName: this.form.lastName,
              birthday: this.form.birthday,
              crib: this.form.crib,
              length: this.form.length,
              weight: this.form.weight,
              languages: JSON.stringify(this.form.selectedLocales),
              hospitalId: this.$store.getters.user.hospital.id
            }
          };
          this.consoleLog(data);

          neoparentPatients
            .addPatient(data)
            .then(result => {
              this.loading = false;
              this.consoleLog(result);

              const post = {
                title: this.$store.getters.user.hospital.hospitalDefaultMessages.onWelcome.title,
                content: this.$store.getters.user.hospital.hospitalDefaultMessages.onWelcome.message?.replace("<p class=\\\"clearfix\\\">","").replace("</p>",""),
                access: "priv",
              }

              neoparentPosts.addPost(result.data.patient.id, post)
                .then(() => {
                    this.$store.commit("updatePatient", result.data.patient);
                    this.redirect(
                      `/dashboard/nurse/${this.$store.getters.user.id}/patient/${result.data.patient.id}`
                    );
                })
            })
            .catch(err => {
              this.loading = false;
              this.error = err.response.data.message;
              window.scrollTo(0, 0);
              this.consoleLog(err);
            });
        } else {
          // Edit patient
          this.consoleLog("Updating patient");

          const data = {
            firstName: this.form.firstName,
            lastName: this.form.lastName,
            crib: this.form.crib,
            languages: JSON.stringify(this.form.selectedLocales),
            hospitalId: this.$store.getters.user.hospital.id
          };
          this.consoleLog(data);

          data.id = this.editId;
          neoparentPatients
            .editPatient(this.editId, data)
            .then(result => {
              this.loading = false;
              this.consoleLog(result);
              this.redirect(
                `/dashboard/nurse/${this.nurseId}/patients`
              );
            })
            .catch(err => {
              this.loading = false;
              this.error = err.response.data.message;
              window.scrollTo(0, 0);
              this.consoleLog(err);
            });
        }
      } else {
        this.error = this.$t("error.policy.mandatoryFields");
        window.scrollTo(0, 0);
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
